import { Box } from "@mui/material";
import { AttributeDetails } from "../mui-components/AttributeValueBox";
import { PricingDetailsCard } from "../mui-components/PricingDetailsCard";
import { useSnapshot } from "valtio";
import { dataListStore, viewBookingStore } from "../state/CommonState";
import Utils from "../util/Utils";
import { useEffect } from "react";
import airlineCodes from "../static-data/airlines";
import { SHIPMENT_SCOPE, SHIPMENT_TYPE } from "../util/constants";




const lclBookingDetails = ({ booking }) => {
    //  let isCarrierFromPricing =  booking?.contractNum === "SPOT" ;
    const baseDetails = [
        { label: "Carrier", key: "carrier", type: "string", targetKey: null, value: process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE },
        { label: "Stuffing Confirmation", key: "stuffing_confirmation", type: "date" },
        { label: "POL Container", key: "pol_container_number", type: "string" },
        { label: `${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} HBL Number`, key: "hbl_number", type: "string" },
        { label: "Coloader HBL Number", key: "coloader_hbl_number", type: "string" },
        { label: "MBL Number", key: "mbl_number", type: "string" },
        { label: "New Carrier Name", key: "new_carrier_name", type: "string" },
        { label: "New Carrier MBL Number", key: "new_carrier_mbl_number", type: "string" },
        { label: "De-stuffing Status at FPOD", key: "destuffing_fpod", type: "date" },
        { label: "Last Free Date at FPOD", key: "last_free_date_at_fpod", type: "date" },
        { label: "Arrival Notice to Consignee", key: "arrival_notice", type: "date" },
        { label: "Cargo Cut-Off", key: "cargo_cutoff", type: "date", notToShowDefault: true },
        { label: "LEO Cut-Off", key: "leo_cutoff", type: "date", notToShowDefault: true },
        { label: "Stuffing Cut-Off", key: "stuffing_cutoff", type: "date", notToShowDefault: true },
        { label: "Delivery Order Release", key: "delivery_order_release", type: "date" },
    ];

    const usIpiDetails = [
        { label: "Container Discharged @ POD", key: "container_discharged_pod", type: "date" },
        { label: "Container Arrived @ Destination CFS", key: "container_arrived_cfs", type: "date" },
        { label: "Container Picked-up from Terminal (Drayage Out)", key: "terminal_drayage_out", type: "date" },
        { label: "Loaded on Rail/Truck for Inland Transit", key: "loaded_for_inland", type: "date" },
        { label: "Cargo Available @ Destination CFS", key: "cargo_available_at_cfs", type: "date" },
        { label: "Custom Release", key: "fpod_customs_release", type: "date" },
        { label: "Freight Release", key: "destination_freight_release", type: "date" },
        { label: "In-Bond Number (CBP 7512 IT)", key: "inbond_number", type: "string" },
        { label: "Destination CFS Warehouse Name", key: "destination_cfs_name", type: "string" },
        { label: "Destination CFS Street Address", key: "destination_cfs_address", type: "string" },
        { label: "US Customs FIRMS Code", key: "cfs_firm_code", type: "string" },
        { label: "Verified Pieces Count", key: "verified_pieces", type: "number" },
        { label: "Package Type", key: "verified_package_type", type: "string" },
        { label: "Verified Gross Weight (kg)", key: "verified_weight_kg", type: "number" },
        { label: "Verified Volume (CBM)", key: "verified_volume_cbm", type: "number" },
        { label: "General Order (G.O.) Date @ FPOD", key: "go_date_fpod", type: "date" },
    ];

    const pod = booking?.pod || booking?.booking?.contract?.portOfDischarge
    const fpod = booking?.fpod || booking?.booking?.contract?.finalPlaceOfDelivery

    return [
        ...baseDetails,
        ...Utils.filterDestinationKeys(usIpiDetails, pod, fpod).map((d) =>
            d.key === "container_discharged_pod" ? { ...d, label: Utils.containerDischargedLabel(pod, fpod) } : d),
        { label: "Special Remarks", key: "remarks", type: "string" }
    ];
}

const fclBookingDetails = ({ booking }) => {
    let isCarrierIsAgraga = booking?.contractRefNum === "SPOT";
    let carrierValue = "";
    if (isCarrierIsAgraga || booking?.contract?.carrier === "") {
        let fclCarrierList = dataListStore["FCLCarrierList"];
        if (fclCarrierList?.length > 0) {
            let carrierName = fclCarrierList.find((list) => list["SCAC code"] === booking.contract.scac);
            if (carrierName) {
                carrierValue = carrierName["Display Name"]
            }
        }
    } else if(booking?.contract?.scac) {
       const regex = new RegExp(`\\(${booking.contract.scac}\\)`, "g");
       carrierValue = booking?.contract?.carrier.replace(regex, "")
    }else if(booking?.contract?.carrier){
        let fclCarrierList = dataListStore["FCLCarrierList"];
        const str = booking.contract.carrier
        const matches = [...str.matchAll(/\(([^)]+)\)/g)];
        console.log(" the matches ",matches); 
if (matches.length > 0) {
  const lastMatch = matches[matches.length - 1][1];

  const exists = fclCarrierList.find((list) => list["SCAC code"] === lastMatch);

  if (exists) {
    const regex = new RegExp(`\\(${lastMatch}\\)\\s*$`);
    carrierValue = str.replace(regex, "").trim();
  }
}
    }
    return [
        { label: "Carrier", key: "carrier", type: "string", targetObject: "booking.contract", value: carrierValue },
        { label: "Carrier Booking Reference #", key: "carrier_booking_ref_number", type: "string" },
        { label: "Carrier Release Order", key: "carrier_booking_release", type: "string" },
        { label: "VGM Cut off", key: "vgm_cut_off", type: "date", notToShowDefault: true },
        { label: "SI Cut-off", key: "shipping_instructions_cut_off", type: "date", notToShowDefault: true },
        { label: "Shipping Bill Cut-off", key: "shipbill_cutoff", type: "date", notToShowDefault: true },
        { label: "Container Gate Cut-off", key: "container_gate_cut_off", type: "date", notToShowDefault: true },
        { label: "Gate Opening", key: "gate_opening", type: "date", notToShowDefault: true },
        { label: "AMS Cut-Off", key: "ams_cutoff", type: "date", notToShowDefault: true },
        { label: "ISF Cut-off", key: "isf_cutoff", type: "date", notToShowDefault: true },
        { label: "Gate Cut off", key: "gate_cut_off", type: "date", notToShowDefault: true },
        { label: "HBL #", key: "hbl_number", type: "string" },
        { label: "Last Free Date at FPOD", key: "last_free_date_at_fpod", type: "date" },
        { label: "Arrival Notice to Consignee", key: "arrival_notice", type: "date" },
        { label: "Delivery Order Release", key: "delivery_order_release", type: "date" },
        { label: "Special Remarks", key: "remarks", type: "string" }
    ]
}
const airBookingDetails = ({ booking }, carrierCode) => {
    let isCarrierFromPricing = booking?.contractRefNum === "SPOT";
  
    return [
        {
            label: "Airline",
            key: "airline",
            type: "string",
            targetObject: "booking.contract",
            formatValue: (value) => {
                const airline = carrierCode || value;

                return airline?.length === 2
                    ? airlineCodes.find(({ code }) => code === airline)?.name || airline
                    : airline;
            }
        },
        { label: "Airline Release Order", key: "airline_booking_release", type: "date" },
        { label: "Airline Booking Reference #", key: "airline_booking_ref_number", type: "string" },
        { label: "Flight number from departure airport", key: "flight_number_departure_airport", type: "string" },
        { label: "HAWB Number", key: "hawb_number", type: "string" },
        { label: "MAWB Number", key: "mawb_number", type: "string" },
        { label: "Arrival notice to consignee", key: "arrival_notice", type: "date" },
        { label: "Last Free Date @ FPOD", key: "last_free_date_at_fpod", type: "date" },
        { label: "Delivery order released to consignee", key: "delivery_order_release", type: "date" },
        { label: "Special Remarks", key: "remarks", type: "string" },
    ]
}


function getTargetObject(objectFrom, keysConcatinatedWithDots) {
    if (!keysConcatinatedWithDots) {
        return objectFrom;
    }
    let keys = keysConcatinatedWithDots?.split(".");
    let targetedObject = objectFrom;
    if (keys && keys.length > 0) {
        keys?.forEach((targetKey) => {
            targetedObject = targetedObject[targetKey];
        })
    }
    return targetedObject
}

export function ShippingDetailsView() {
    const booking = viewBookingStore.current
    const isAir = booking.booking.contract.shipmentType === "Air";
    const isFcl = booking.booking.contract.shipmentType.includes("FCL");
    const isLcl = booking.booking.contract.shipmentType.includes("LCL");
    const shipmentScope = booking.booking.contract.shipmentScope
    const shipmentType = booking.booking.contract.shipmentType
    let gateInCFS = false
    if ((shipmentScope === SHIPMENT_SCOPE.p2d || shipmentScope === SHIPMENT_SCOPE.p2p) && !(shipmentType === SHIPMENT_TYPE.fcl_f_f || shipmentType === SHIPMENT_TYPE.fcl_f_cfs)) {
        gateInCFS = true
    }

    let showDetailsMasterArray = [];

    if (isAir) {
        showDetailsMasterArray = [...airBookingDetails(booking, booking.carrier)];
        if (gateInCFS) {
            showDetailsMasterArray.push({ label: "Gate-in at Cargo Terminal", key: "arrival_dispatch_airport", type: "date" })
        }
        for (let i = 1; i < 5; i++) {
            const key = `flight_number_ts${i}`
            if (booking[key] && booking[key].length > 0) {
                showDetailsMasterArray.push({ label: `Flight number from transhipment ${i} airport`, key, type: "string" })
            }
        }
    } else if (isLcl) {
        if (booking?.shipmentType == 'LCL' && booking?.containerType) {
            booking.pol_container_number = booking.pol_container_number + '(' + booking?.containerType + ')'
        }
        showDetailsMasterArray = [...lclBookingDetails(booking)]
        if (gateInCFS) {
            showDetailsMasterArray.push({ label: "Cargo Gate-in at CFS", key: "cargo_gatein_CFS", type: "date" })
        }
        if (booking["reworking_at_pol"]?.toLowerCase() === "yes") {
            showDetailsMasterArray.push({ label: "De-stuffing Status", key: "destuffing_at_pol", type: "date" });
            showDetailsMasterArray.push({ label: "Re-stuffing Status", key: "restuffing_at_pol", type: "date" });
        }
    } else if (isFcl) {
        showDetailsMasterArray = [...fclBookingDetails(booking)]
        if (gateInCFS) {
            showDetailsMasterArray.push({ label: "Cargo Gate-in at CFS", key: "cargo_gatein_CFS", type: "date" })
        }
    }

    // if(Utils.checkForAtlestOneValue(showDetailsMasterArray,(bookingDetail)=>getTargetObject(booking, bookingDetail.targetObject))){

    return <Box sx={{ paddingX: "10px" }}><AttributeDetails details={showDetailsMasterArray.map((bookingDetail) => {
        const objectToBeSearched = getTargetObject(booking, bookingDetail.targetObject);

        return { title: bookingDetail.label,notToShowDefault:true, value: bookingDetail.value ? bookingDetail.value : bookingDetail.type === "date" ? Utils.formatDateBooking(objectToBeSearched[bookingDetail.key], false) : bookingDetail.formatValue ? bookingDetail.formatValue(objectToBeSearched[bookingDetail.key]) : objectToBeSearched[bookingDetail.key] }
    }
    )} /></Box>
    // }else{
    //     return <></>
    // }

}